import React, { useState } from 'react';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { useHistory, useLocation } from 'react-router-dom';

import A from '../../../common/A';
import URL from '../../../../constant/URL';
import useLearningData from '../../../../hooks/useLearningData';
import TYPE from '../../../../constant/TYPE';
import useConceptCheckPlayer from '../../../../hooks/useConceptCheckPlayer';
import ConceptCheckPlayerBox from '../../../common/iframe/ConceptCheckPlayerBox';
import { useLearningBtn } from '../../../../hooks';

/**
 * 진도학습 바로셈, 교과수학진도 List Component
 */
function ProgressList({ list, noMsg, learningEntryType }) {
  const history = useHistory();
  const location = useLocation();
  const [goLearning] = useLearningBtn();
  const { setLearningData } = useLearningData();
  // const { info } = useUserInfo(); // 회원정보
  const [ ,setConceptPopup ] = useConceptCheckPlayer();  // 개념확인 팝업
  
  const handlePage = (item) => {
    localStorage.setItem('learning.id', TYPE.LEARNING.TOPIC);
    let pathname = `${URL.LEARNING.RESULT}`;
    setLearningData({ prevPage : 'progressLearing/aibarosem' });
    setLearningData({ stgCd: item.stgCd });
    
    // 문제풀이로
    if(item.lrnEndDt === null || item.lrnEndDt === '' || item.lrnEndDt === undefined) {
      goLearning({
        stage: item.stgCd,
        learningEntryType,
        lrnEntyScnCd: TYPE.LEARNING.TOPIC,
      });
      return;
    }
    // 결과페이지로
    console.log(`***** ${location.pathname} 페이지에서 토픽 클릭 -> 결과 페이지`)
    history.push({
      pathname,
      state: {
        stgCd: item.stgCd
      }
    });
  }
  
  return (
    <React.Fragment>
      <ConceptCheckPlayerBox />
      <div className="progress_study">
        {
          (!list || list.length === 0)
            ? (
              <div className="empty">
                <span>{noMsg}</span>
              </div>
            )
            : (
              <div className="sl-section">
                <ul className="sl-section_list gm">
                  {
                    list.map((item, index) => (
                      <Items
                        item={item}
                        key={index}
                        handlePage={handlePage}
                        setConceptPopup={setConceptPopup}
                      />
                    ))
                  }
                </ul>
              </div>
            )
        }
      </div>
    </React.Fragment>
  );
}

function Items({ item, handlePage, setConceptPopup }) {
  const { t } = useTranslation();
  const [isMsg, setIsMsg] = useState(true);
  const handleMsg = () => setIsMsg(false);
  const handleClick = (e, item) => {
    console.log(`***** 진도학습 - 개념확인 모달(${item.stgNm}) 오픈`)
    e.preventDefault();
    setConceptPopup({ url: item.cncpMeta, title: item.stgNm, onOff: true });
  }
  return (
    <li
      id={(item.lastStgYn === "Y" && isMsg) ? 'lastStage' : 'stage'}
    >
      {/* <button onClick={(e) => handleClick(e, item)}>개념확인버튼 Test</button> */}
      <A onClick={() => handlePage(item)}>
        <div className="sl-calcBox">
          { item.lrnPrgsStsCd === 'LPSC01' && <span className="ico ico-effort"></span>}
          { item.lrnPrgsStsCd === 'LPSC02' && <span className="ico ico-def"></span>}
          { item.lrnPrgsStsCd === 'LPSC03' && <span className="ico ico-enough"></span>}
          { item.lrnPrgsStsCd === 'LPSC04' && <span className="ico ico-nice"></span>}
          <img
            src={`${item.stgImgFilePath}${item.stgImgFileNm}`}
            alt={item.stgImgFileNm}
          />
        </div>
      </A>
      <div className="sl-txtBox">
        <p className="sl-txtBox_txt">
          {item.stgNm}
        </p>
        <p className="sl-txtBox_date">
          {
            item.lrnEndDt && (
              <>
                <span>
                  {moment(item.lrnEndDt).format('YYYY. MM. DD')}
                </span>
                <span className="bar">세로선</span>
              </>
            )
          }
          <A
            style={{cursor: 'pointer'}}  
            onClick={(e) => handleClick(e, item)}
          >{t("LC_06_01.msg008")}</A>
        </p>
      </div>
      {
        (item.lastStgYn === "Y" && isMsg) && (
          <div id="last" className="tooltip-def tooltipBox active">
            <p>
              <span dangerouslySetInnerHTML={{ __html: t("LC_06_01.msg007") }} />
              <button
                // style={{ top: -88 }}
                onClick={handleMsg}
                className="btn-closeTooltip btn-close-tooltip"
              />
            </p>
          </div>
        )
      }
    </li>
  )
}

export default ProgressList;